<div *ngIf="isHidden" class="d-flex align-items-center automation-warning p-10 mt-10 mb-10">
  <i class="icon-ico_eye_off automated-icon top-message me-2"></i>
  This page was hidden from end-users.
</div>
<ey-froala-content-wrapper *ngFor="let prop of page.moduleFlowPage?.properties" [editorContent]="prop.content"></ey-froala-content-wrapper>
